<template>
  <section>
    <!--工具条-->
    <CustomerToolbar :buttonList="buttonList" @callFunction="callFunction"></CustomerToolbar>

    <!--列表-->
    <el-table :data="customs" highlight-current-row v-loading="listLoading" @current-change="selectCurrentRow"
      style="width: 100%;">
      <el-table-column fixed="left" type="index" label="序号" width="80"></el-table-column>
      <el-table-column fixed="left" label="操作" width="80">
        <template slot-scope="scope">
          <span v-for="item in operationButtonList" :key="item.id">
            <el-button type="text" style="padding-right:6px;" size="small" v-if="!item.IsHide"
              @click="operationButtonFunction(item, scope.row)">{{ item.name }}</el-button>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="CustomName" fixed="left" label="客户名称" width="180" sortable></el-table-column>
      <el-table-column prop="FeatureName" fixed="left" label="图元名称" width="180" sortable></el-table-column>
      <el-table-column prop="Enabled" fixed="left" label="状态" width="80" sortable>
        <template slot-scope="scope">
          <el-tag :type="scope.row.Enabled ? 'success' : 'danger'" disable-transitions>{{ scope.row.Enabled ?
            "正常" : "禁用" }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="CBLAccount" label="车百路账号" width="120" sortable></el-table-column>
      <el-table-column prop="CBLPassword" label="车百路密码" width="120" sortable></el-table-column>
      <el-table-column prop="AppCode" label="应用编码" width="120" sortable></el-table-column>
      <el-table-column prop="AuthorizationCode" label="应用授权码" width="260" sortable></el-table-column>
      <el-table-column prop="Url" label="三局云砼Url" width="300" sortable></el-table-column>
      <el-table-column prop="IntervalMinutes" label="间隔分钟数" width="110" ></el-table-column>
      <el-table-column prop="StartTime" label="开始时间" :formatter="formatStartTime" width="160"
          sortable></el-table-column>
      <el-table-column prop="EndTime" label="截止时间" :formatter="formatEndTime" width="160"
          sortable></el-table-column>
      <el-table-column prop="Contacts" label="联系人" width="120" sortable></el-table-column>
      <el-table-column prop="Phone" label="联系电话" width="120" sortable></el-table-column>
      <el-table-column prop="Address" label="地址" width="200" sortable></el-table-column>
      <el-table-column prop="Remark" label="备注" width="200" sortable></el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="Toolbar">
      <el-pagination layout="total, sizes, prev, pager, next" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page.sync="page" :page-sizes="[10, 15, 20, 50, 100, 200]"
        :total="total" style="float:right;"></el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
      <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
        <el-row>
          <el-col :span="10">
            <el-form-item label="客户名称" prop="CustomName" label-width="100px">
              <el-input v-model="addForm.CustomName" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="图元名称" prop="FeatureName" label-width="100px">
              <el-input v-model="addForm.FeatureName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="状态" prop="Enabled" label-width="100px">
              <el-select v-model="addForm.Enabled" placeholder="请选择客户状态">
                <el-option label="激活" value="true"></el-option>
                <el-option label="禁用" value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="秘钥" prop="SecretKey" label-width="100px">
              <el-input v-model="addForm.SecretKey" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="车百路账号" prop="CBLAccount" label-width="100px">
              <el-input v-model="addForm.CBLAccount" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="车百路密码" prop="CBLPassword" label-width="100px">
              <el-input v-model="addForm.CBLPassword" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="应用编码" prop="AppCode" label-width="100px">
              <el-input v-model="addForm.AppCode" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="应用授权码" prop="AuthorizationCode" label-width="100px">
              <el-input v-model="addForm.AuthorizationCode" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="三局云砼Url" prop="Url" label-width="100px">
              <el-input v-model="addForm.Url" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="间隔分钟数" prop="IntervalMinutes" label-width="100px">
              <el-input-number v-number-only v-model="addForm.IntervalMinutes" :min="0" :max="1000" style="width:150px" ></el-input-number>  分钟
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="联系人" prop="Contacts" label-width="100px">
              <el-input v-model="addForm.Contacts" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="联系电话" prop="Phone" label-width="100px">
              <el-input v-model="addForm.Phone" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="开始时间" prop="StartTime" label-width="110px">
              <el-date-picker v-model="addForm.StartTime" type="datetime" placeholder="请选择开始时间" value-format="yyyy-MM-dd HH:mm:ss" style="width:183px;"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="截止时间" prop="EndTime" label-width="110px">
              <el-date-picker v-model="addForm.EndTime" type="datetime" placeholder="请选择截止时间" value-format="yyyy-MM-dd HH:mm:ss" style="width:183px;"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="地址" prop="Address" label-width="100px">
            <el-input rows="2" type="textarea" v-model="addForm.Address" auto-complete="off"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="备注" prop="Remark" label-width="100px">
            <el-input rows="3" type="textarea" v-model="addForm.Remark" auto-complete="off"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
      <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
        <el-row>
          <el-col :span="10">
            <el-form-item label="客户名称" prop="CustomName" label-width="100px">
              <el-input v-model="editForm.CustomName" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="图元名称" prop="FeatureName" label-width="100px">
              <el-input v-model="editForm.FeatureName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="状态" prop="Enabled" label-width="100px">
              <el-select v-model="editForm.Enabled" placeholder="请选择客户状态">
                <el-option
                    v-for="item in statusList"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="秘钥" prop="SecretKey" label-width="100px">
              <el-input v-model="editForm.SecretKey" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="车百路账号" prop="CBLAccount" label-width="100px">
              <el-input v-model="editForm.CBLAccount" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="车百路密码" prop="CBLPassword" label-width="100px">
              <el-input v-model="editForm.CBLPassword" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="应用编码" prop="AppCode" label-width="100px">
              <el-input v-model="editForm.AppCode" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="应用授权码" prop="AuthorizationCode" label-width="100px">
              <el-input v-model="editForm.AuthorizationCode" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="三局云砼Url" prop="Url" label-width="100px">
              <el-input v-model="editForm.Url" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="间隔分钟数" prop="IntervalMinutes" label-width="100px">
              <el-input-number v-number-only v-model="editForm.IntervalMinutes" :min="0" :max="1000" style="width:150px" ></el-input-number>  分钟
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="联系人" prop="Contacts" label-width="100px">
              <el-input v-model="editForm.Contacts" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="联系电话" prop="Phone" label-width="100px">
              <el-input v-model="editForm.Phone" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="开始时间" prop="StartTime" label-width="100px">
              <el-date-picker v-model="editForm.StartTime" type="datetime" placeholder="请选择开始时间" value-format="yyyy-MM-dd HH:mm:ss" style="width:195px;"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="截止时间" prop="EndTime" label-width="100px">
              <el-date-picker v-model="editForm.EndTime" type="datetime" placeholder="请选择截止时间" value-format="yyyy-MM-dd HH:mm:ss" style="width:195px;"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="地址" prop="Address" label-width="100px">
            <el-input rows="2" type="textarea" v-model="editForm.Address" auto-complete="off"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="备注" prop="Remark" label-width="100px">
            <el-input rows="3" type="textarea" v-model="editForm.Remark" auto-complete="off"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--操作日记-->
    <el-dialog title="操作日记" :visible.sync="operateDataLogFormVisible" v-model="operateDataLogFormVisible"
      :close-on-click-modal="false" :destroy-on-close="true" width="60%">
      <OperateDataLog v-if="operateDataLogFormVisible" :entityName="entityName" :entityKey="entityKey"></OperateDataLog>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="operateDataLogFormVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import { getCustomerListPage, removeCustomer, editCustomer, addCustomer, initVehicleInfo, initFeatureData } from "../../api/api";
import { getButtonList, getOperationButtonList } from "../../promissionRouter";
import CustomerToolbar from "../../components/QueryToolbar/CustomerToolbar";
import OperateDataLog from "../../components/OperateDataLog";

export default {
  components: { CustomerToolbar, OperateDataLog },
  data() {
    return {
      filters: {
        companyName: "",
        enabled: "true"
      },
      entityName: 'Customer', //操作日记中的表名称
      entityKey: '',  //操作日记中的表的Id
      buttonList: [],
      operationButtonList: [],
      customs: [], //客户列表
      statusList: [
        { name: "激活", value: true },
        { name: "禁用", value: false }
      ],
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      operateDataLogFormVisible: false, //查看操作日记界面是否显示
      editLoading: false,
      editFormRules: {
        CustomName: [{ required: true, message: "请输入客户名称", trigger: "blur" }], 
        FeatureName: [{ required: true, message: "请输入图元名称", trigger: "blur" }],
        SecretKey: [{ required: true, message: "请输入秘钥", trigger: "blur" }],
        Enabled: [{ required: true, message: "请选择状态", trigger: "blur" }],
        CBLAccount: [{ required: true, message: "请输入车百路账号", trigger: "blur" }],
        CBLPassword: [{ required: true, message: "请输入车百路密码", trigger: "blur" }],
        StartTime: [{ required: true, message: "请选择开始时间", trigger: "blur" }],
        EndTime: [{ required: true, message: "请选择截止时间", trigger: "blur" }]
      },
      
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        CustomName: [{ required: true, message: "请输入客户名称", trigger: "blur" }],
        FeatureName: [{ required: true, message: "请输入图元名称", trigger: "blur" }],
        SecretKey: [{ required: true, message: "请输入秘钥", trigger: "blur" }],
        Enabled: [{ required: true, message: "请选择状态", trigger: "blur" }],
        CBLAccount: [{ required: true, message: "请输入车百路账号", trigger: "blur" }],
        CBLPassword: [{ required: true, message: "请输入车百路密码", trigger: "blur" }],
        StartTime: [{ required: true, message: "请选择开始时间", trigger: "blur" }],
        EndTime: [{ required: true, message: "请选择截止时间", trigger: "blur" }]
      },
      //新增界面数据
      addForm: {
        CreateBy: "",
        CreateId: "",
        CustomName: "",
        FeatureName: "",
        SecretKey: "",
        Enabled: "true",
        CBLAccount: "",
        CBLPassword: "",
        AppCode: "",
        AuthorizationCode: "",
        Url: "",
        IntervalMinutes:0,
        Contacts: "",
        Phone: "",
        StartTime: "",
        EndTime: "",
        Address: "",
        Remark: ""
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        CreateBy: "",
        CustomName: "",
        FeatureName: "",
        SecretKey: "",
        Enabled: "false",
        CBLAccount: "",
        CBLPassword: "",
        AppCode: "",
        AuthorizationCode: "",
        Url: "",
        IntervalMinutes: 0,
        Contacts: "",
        Phone: "",
        StartTime: "",
        EndTime: "",
        Address: "",
        Remark: ""
      },
    };
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        customName: item.customName,
        enabled: item.enabled
      };
      this[item.Func].apply(this, item);
    },
    operationButtonFunction(item, row) {
      this.currentRow = row;
      this[item.Func].apply(this, item);
    },
    formatStartTime: function (row, column) {
      return !row.StartTime || row.StartTime == ""
        ? ""
        : util.formatDate.format(new Date(row.StartTime), "yyyy-MM-dd hh:mm:ss");
    },
    formatEndTime: function (row, column) {
      return !row.EndTime || row.EndTime == ""
        ? ""
        : util.formatDate.format(new Date(row.EndTime), "yyyy-MM-dd hh:mm:ss");
    },
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.getCustomer();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getCustomer();
    },
    queryCustomer() {
      this.page = 1;
      this.getCustomer();
    },
    //获取客户列表
    getCustomer() {
      let _this = this;
      let para = {
        customName: _this.filters.customName,
        enabled: _this.filters.enabled,
        page: _this.page,
        pageSize: _this.pageSize
      };
      _this.listLoading = true;
      getCustomerListPage(para).then(res => {
        _this.total = res.data.response.dataCount;
        _this.customs = res.data.response.data;
        _this.listLoading = false;
      });
    },
    // 初始化用户关联车辆数据
    handleInitVehicleInfo() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要初始化车辆数据的一行！",
          type: "error"
        });

        return;
      }
      this.$confirm("确认初始化车辆数据吗?", "提示", {
        type: "warning"
      })
        .then(() => {
          let para = { customerId: row.Id };
          initVehicleInfo(para).then(res => {
            if (util.isEmt.format(res)) {
              return;
            }
            if (res.data.success) {
              this.$message({
                message: "初始化车辆数据成功",
                type: "success"
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error"
              });
            }
          });
        })
        .catch(() => { });
    },
    // 初始化图元数据
    handleInitFeatureData() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要初始化车辆数据的一行！",
          type: "error"
        });

        return;
      }
      this.$confirm("确认初始化车辆数据吗?", "提示", {
        type: "warning"
      })
        .then(() => {
          let para = { customerId: row.Id };
          initFeatureData(para).then(res => {
            if (util.isEmt.format(res)) {
              return;
            }
            if (res.data.success) {
              this.$message({
                message: "初始化图元数据成功",
                type: "success"
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error"
              });
            }
          });
        })
        .catch(() => { });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning"
      })
        .then(() => {
          this.listLoading = true;
          let para = { id: row.Id };
          removeCustomer(para).then(res => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success"
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error"
              });
            }

            this.getCustomer();
          });
        })
        .catch(() => { });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });

        return;
      }

      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        CreateBy: "",
        CustomName: "",
        Enabled: "true"
      };
    },
    //查看操作日记
    lookUpOperateDataLog() {
      this.operateDataLogFormVisible = true;
      this.entityKey = this.currentRow.Id;
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            let para = Object.assign({}, this.editForm);

            editCustomer(para).then(res => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }

              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.getCustomer();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let para = Object.assign({}, this.addForm);

            var user = JSON.parse(window.localStorage.user);

            if (user && user.uID > 0) {
              para.CreateId = user.uID;
              para.CreateBy = user.uRealName;
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error"
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            addCustomer(para).then(res => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              if (res.data.success) {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getCustomer();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function () {
      this.$message({
        message: "该功能未开放",
        type: "warning"
      });
    },
    getButtonList2(routers) {
      let _this = this;
      routers.forEach(element => {
        let path = this.$route.path.toLowerCase();
        if (element.path && element.path.toLowerCase() == path) {
          _this.buttonList = element.children;
          return;
        } else if (element.children) {
          _this.getButtonList(element.children);
        }
      });
    }
  },
  mounted() {
    this.getCustomer();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    this.buttonList = getButtonList(this.$route.path, routers);
    this.operationButtonList = getOperationButtonList(this.$route.path, routers);
  }
}
</script>

<style scoped></style>
